import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/park/led/template/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/park/led/template/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/park/led/template/remove', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/park/led/template/submit', params, options);

export const update = (params, options) =>
  request.post('/api/park/led/template/submit', params, options);
